import React, { useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import useScid from 'common/use-scid'
import api from 'common/api'
import { actions as snactions } from 'store/snackbar'
import CollegeMetrics from './Context'
import { reducer, INITIAL_STATE } from './reducer'

const CollegeMetricsProvider = ({ children }) => {
  const scid = useScid()
  const [{ error, loading, collegeMetrics }, dispatch] = useReducer(reducer, INITIAL_STATE)
  const snackDispatch = useDispatch()
  useEffect(() => {
    dispatch({ type: 'loading' })
    api
      .get(`/api/colleges/${scid}/metrics`)
      .then((data) => dispatch({ type: 'loaded', data }))
      .catch(() => {
        dispatch({ type: 'error' })
        snackDispatch(snactions.addSnackbarItem('An error occurred while retrieving college metrics'))
      })
  }, [scid, snackDispatch])
  return (
    <CollegeMetrics.Provider
      value={{
        error,
        loading,
        collegeMetrics,
      }}
    >
      {children}
    </CollegeMetrics.Provider>
  )
}
CollegeMetricsProvider.propTypes = {
  children: PropTypes.any.isRequired,
}

export default CollegeMetricsProvider
